import {
  getData,
  postData
} from './api-base.service';
import {
  QuestionnaireEx
} from "@/model/questionnaireEx";

export const getStudentCoursesQuestionnaireStatus = (studentId) => {
  let data = {
    studentId
  };

  return getData('/Questionnaire/GetStudentCoursesQuestionnaireStatus', data);
};

export const getStudentActiveQuestionnaires = async (studentId, courseId, termId = null) => {
  let data = {
    studentId,
    courseId,
    termId
  };

  let result = await getData('/Questionnaire/GetStudentActiveQuestionnaires', data);
  if (!!result && result.success) {
    result.data.ActiveQuestionnaires = result.data.ActiveQuestionnaires.map(item => new QuestionnaireEx(item));
  }
  return result;
}

export const saveStudentQuestionnaireRecords = (data) => {
  return postData('/Questionnaire/SaveStudentQuestionnaireRecords', data);
}



// WEBPACK FOOTER //
// ./src/service/questionnaire.service.js